<script setup lang="ts">
import { useConfirm, VIcons, VModal } from '@/shared/ui'
import { useObjectReplace } from './../model/model'
import './assets/style.scss'
import { ObjectSearch } from '@/widgets'
import { useSendForm } from './../model/api.ts'
import { useTranslate } from '@/shared/lib'

const model = useObjectReplace()
const { sendForm } = useSendForm()

const { show } = useConfirm()
const { trs } = useTranslate()

/**
 * Функция подтверждения перемещения объекта
 */
const submitHandler = () => {
  show({
    title: trs('itf.is_replace_object'),
    confirmFunc: () => sendForm(model.data).then(() => model.clearObjects()),
  })
}
</script>

<template>
  <VModal v-model="model.open">
    <template #title>
      <VIcons type="sync_alt" /> {{ $t('itf.replace_title') }}: {{ model.data.object_name }}
    </template>

    <VForm @submit.prevent="submitHandler">
      <ObjectSearch
        class="mt-2"
        v-model="model.data.object_to"
        :object_type="model.data.object_type"
        :label="$t('itf.replace_object')"
        fixed_height
      />

      <div class="form__btn_right mt-2">
        <VBtn type="submit" :disabled="!model.data.object_to">
          {{ $t('itf.replace') }}
        </VBtn>

        <VBtn color="default" @click="model.clearObjects">
          {{ $t('itf.cancel') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
